import { ObservableSocket } from "@game.object/ts-game-toolbox/dist/src/signals/ObservableSocket";
import p5 from "p5";
import { GameController } from "../base/GameController";
import { View } from "./View";

export interface ViewAskForNumberData {
    current_guess: ObservableSocket<number>;
}

export class ViewAskForNumber extends View {
    protected data: ViewAskForNumberData;

    public constructor(public p: p5, protected controller: GameController, data: ViewAskForNumberData) {
        super();
        this.data = data;
    }

    public load() {
        document.addEventListener("keypress", this.on_keypress_func);
        document.addEventListener("keydown", this.on_keydown_func);
    }

    public unload() {
        document.removeEventListener("keypress", this.on_keypress_func);
        document.removeEventListener("keydown", this.on_keydown_func);
    }

    public draw() {
        this.p.background(0);
        this.p.stroke(255);
        this.p.textSize(32);
        this.p.text("Enter a number and press ENTER", 200, 270);
        const number = this.data.current_guess.get();
        this.p.text(" => " + (number || '').toString(), 200, 300);
    }


    private on_keydown_func = (event: KeyboardEvent): void => {
        if (event.key === "Escape") {
            this.controller.reset_guess();
            return;
        }
        if (event.key === "Backspace") {
            this.controller.delete_digit();
            return;
        }
    };

    private on_keypress_func = (event: KeyboardEvent): void => {
        const number = Number.parseInt(event.key);
        if (event.key === "Enter") {
            this.controller.check_if_number_is_correct();
            return;
        }
        if (!isNaN(number)) {
            this.controller.add_digit_to_number(number);
            return;
        }
    };
}